export enum ItemsToCopyField {
  COSTS = 'costs',
  FREIGHT = 'freight',
  LINE_NOTES = 'lineNotes',
  LOCKS = 'locks',
  PARTS = 'parts',
  PRICES = 'prices',
  PRICING_DATES = 'pricingDates',
  QUANTITIES = 'quantities',
  QUOTE_CUSTOMER_NOTE = 'quoteCustomerNote',
  QUOTE_INTERNAL_NOTE = 'quoteInternalNote',
  UOMS = 'uoms',
  VENDOR_QUOTES = 'vendorQuotes',
}

export type ItemsToCopyApiValue =
  | 'costs'
  | 'freight'
  | 'line_notes'
  | 'locks'
  | 'parts'
  | 'prices'
  | 'pricing_dates'
  | 'quantities'
  | 'quote_customer_note'
  | 'quote_internal_note'
  | 'uoms'
  | 'vendor_quotes';

export enum CopyNoteType {
  MERGE = 'merge',
  OVERRIDE = 'override',
}
